module.exports = {"id":null,"uraian":null,"jumlah_kemasan":null,"jenis_kemasan":null,"jumlah_satuan":null,"jenis_satuan":null,"fob":null,"insurance":null,"freight":null,"hs_id":null,"kurs_id":null,"brutto":null,"netto":null,"kategori_tags":[],"is_penetapan":false,"kurs":{"data":null},"hs":{"data":null},"detailSekunder":{"data":[]},"kemasan":{"data":null},"satuan":{"data":null},"tarif":{"data":[]},"fasilitas":{"data":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/defaultDetailBarang.json
// module id = SR2X
// module chunks = 1